import AutoVisitConfigSection from '../GpsLoadSettingsPage/AutoVisitConfigSection';
import { Typography, Stack } from '@mui/material';
const AutoVisitSettingsPage = () => (
  <Stack>
    <Stack
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        gap: '16px',
        marginBottom: '4px',
        direction: 'rtl',
        [theme.breakpoints.down('lg')]: {
          display: 'grid',
        },
        flexDirection: 'row',
        [theme.breakpoints.down('sm')]: {
          minWidth: '0',
          gap: '12px',
          position: 'relative',
          paddingLeft: '0',
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          width: '100%',
        },
      })}
    >
      <Stack>
        <Typography
          sx={{
            fontSize: 20,
            fontWeight: 'bold',
          }}
        >
          הגדרות דיווח אוטומטי
        </Typography>

        <Typography>ניהול Remote Config עבור Auto Visit במכשירי Android</Typography>
      </Stack>
    </Stack>

    <AutoVisitConfigSection />
  </Stack>
);
export default AutoVisitSettingsPage;
